type LandingPermissions = {
  MAP_LIST_VIEW?: boolean;
  SITE_SUMMARY?: boolean;
};

/**
 * Same landing targets as DefaultRedirect after a successful session.
 */
export const getPostLoginPath = (
  permissions: LandingPermissions = {},
  { signedIn = true }: { signedIn?: boolean } = {}
) => {
  if (!signedIn) {
    return '/login';
  }

  if (permissions.MAP_LIST_VIEW) {
    return '/turbines';
  }

  if (permissions.SITE_SUMMARY) {
    return '/locations';
  }

  return '/';
};
